import { MedienverleumdungEntry } from '../model/medienverleumdung';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface MedienverleumdungSearchParams extends AbstractSearchParams {
  person?: string;
  media?: string;
  date?: string;
  date_from?: string;
  date_to?: string;
  title?: string;
}

export class MedienverleumdungRepository extends RepositoryNocoDbBase<
  MedienverleumdungEntry,
  MedienverleumdungSearchParams
> {
  protected readonly TABLE_NAME = 'medienverleumdungen';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'date';

  protected readonly SORT_BY_DATE_FIELD = true;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['person', 'media'];

  protected readonly EQUAL_FILTERS = ['person'];

  protected readonly SEARCH_FIELDS: (keyof MedienverleumdungEntry)[] = [
    'title',
    'person',
    'what_happened',
    'my_correction',
    'media'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
